/**
 * @generated SignedSource<<02001d8e27d36ddccb05b2ca2744313c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Gender = "FEMALE" | "MALE" | "PRIVATE" | "%future added value";
export type Units = "METRIC" | "US" | "%future added value";
export type UpdateUserInput = {
  admin?: boolean | null | undefined;
  birthday?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  displayName?: string | null | undefined;
  gender?: Gender | null | undefined;
  height?: string | null | undefined;
  id: string;
  location?: string | null | undefined;
  passwordUpdated?: boolean | null | undefined;
  phone?: string | null | undefined;
  phoneCode?: string | null | undefined;
  photoURL?: string | null | undefined;
  themeOptions?: string | null | undefined;
  timeZone?: string | null | undefined;
  topToolbar?: boolean | null | undefined;
  trialExpiryDate?: string | null | undefined;
  units?: Units | null | undefined;
  username?: string | null | undefined;
  weight?: string | null | undefined;
};
export type ClientSettingsDialogUpdateUserMutation$variables = {
  input: UpdateUserInput;
};
export type ClientSettingsDialogUpdateUserMutation$data = {
  readonly updateUser: {
    readonly user: {
      readonly " $fragmentSpreads": FragmentRefs<"ClientSettingsDialog_client">;
    } | null | undefined;
  } | null | undefined;
};
export type ClientSettingsDialogUpdateUserMutation = {
  response: ClientSettingsDialogUpdateUserMutation$data;
  variables: ClientSettingsDialogUpdateUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientSettingsDialogUpdateUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ClientSettingsDialog_client"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientSettingsDialogUpdateUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "photoURL",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gender",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "location",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "birthday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "units",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "height",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weight",
                "storageKey": null
              },
              {
                "alias": "rawDisplayName",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "raw",
                    "value": true
                  }
                ],
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": "displayName(raw:true)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "username",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeZone",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Tag",
                "kind": "LinkedField",
                "name": "tag",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationsSetting",
                "kind": "LinkedField",
                "name": "notificationsSetting",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "newMessageEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "newResponseEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weeklyUpdate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dailyUpdate",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fd7d4cbaeb8675cfeaba9d238bfe78b1",
    "id": null,
    "metadata": {},
    "name": "ClientSettingsDialogUpdateUserMutation",
    "operationKind": "mutation",
    "text": "mutation ClientSettingsDialogUpdateUserMutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    user {\n      ...ClientSettingsDialog_client\n      id\n    }\n  }\n}\n\nfragment ClientSettingsDialog_client on User {\n  ...ClientSettingsForm_settings\n  id\n  rawDisplayName: displayName(raw: true)\n  username\n  tag {\n    title\n    id\n  }\n  notificationsSetting {\n    ...ClientSettingsDialog_notificationsSetting\n    newMessageEmail\n    newResponseEmail\n    weeklyUpdate\n    dailyUpdate\n    id\n  }\n}\n\nfragment ClientSettingsDialog_notificationsSetting on NotificationsSetting {\n  newMessageEmail\n  newResponseEmail\n  weeklyUpdate\n  dailyUpdate\n}\n\nfragment ClientSettingsForm_settings on User {\n  email\n  photoURL\n  gender\n  location\n  birthday\n  units\n  height\n  weight\n  rawDisplayName: displayName(raw: true)\n  username\n  timeZone\n}\n"
  }
};
})();

(node as any).hash = "ae5a132092022c00e996ac0ca5766239";

export default node;
